import {sharableDashboardManagerConfig} from './component';
import '../../services/state-service';

export default angular.module('sharable-dashboard.manager', [
    'ngRoute',
    'pascalprecht.translate',
    'sharable-dashboard.state-service',
    'MW.Framework.CoreCompanyService'
])
.config(['$routeProvider', '$locationProvider', '$httpProvider', '$windowProvider', 'FAIRHAIR_WEB_URL', function ($routeProvider, $locationProvider, $httpProvider, $windowProvider, FAIRHAIR_WEB_URL) {
    'use strict';

    // $routeProvider.otherwise({
    //     redirectTo: '/sharable-dashboard-manager'
    // });
    $routeProvider.otherwise({
        redirectTo: function (routeParams, path, search) {
            if(path === '/') {
                // If the path is simply '/', then assume they're trying to get the the home of the app
                return '/sharable-dashboard-manager';
            } else if(path[0] === '/') {
                // But, if we're here in the otherwise() and if the path is more but STARTS with '/', then we have no option other than to assume it's trying to go to another nav item
                $windowProvider.$get().location.href = FAIRHAIR_WEB_URL + path;
            }
        }
    });

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });
    $locationProvider.hashPrefix('!');

    $httpProvider.defaults.cache = false;

    $httpProvider.interceptors.push('AuthTokenHttpInterceptor');
    $httpProvider.interceptors.push('VerifyAccessHttpInterceptor');

}])
.config(['$routeProvider', function ($routeProvider) {
    'use strict';

    $routeProvider.when('/sharable-dashboard-manager/:shareLimitReached?', {
        template: function(params) {
            return '<mw-pr-insight-sharable-dashboard-report-manager ' +
                        'share-limit-reached="' + (params.shareLimitReached !== undefined ? params.shareLimitReached : false) + '" ' +
                        'company-id="$resolve.companyId" ' +
                        'items="$resolve.items">' +
                    '</mw-pr-insight-sharable-dashboard-report-manager>'
        },
        activeTab: 'manager',
        resolve: {
            companyId: function getCompanyId(CoreCompanyService) {
                return CoreCompanyService.getCurrent(true).then(function (company) {
                    return company._id || '';
                });
            },
            items: function getSharableDashboards(CoreCompanyService, $http) {
                return CoreCompanyService.getCurrent(true).then(function (company) {
                    return $http.get('/aws/dynamoDb/sharableDashboards/' + company._id).then(function (sharedDashboards) {
                        if(Array.isArray(sharedDashboards.data) && sharedDashboards.data.length > 0) {
                            sharedDashboards.data.forEach(function (dashboard) {
                                if(typeof dashboard.displayName === 'undefined' || dashboard.displayName === null) {
                                    dashboard.displayName = dashboard.title;
                                }
                            });
                            return sharedDashboards.data;
                        } else {
                            return [];
                        }
                    });
                });
            }
        },
        title: 'Dashboards',
        reloadOnSearch: false
    });
}])
.component(sharableDashboardManagerConfig.name, sharableDashboardManagerConfig);
